
export const debounce = (callback, time = 250) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => callback(...args), time);
  };
};

export const isNumeric = val => !Array.isArray(val) && (val - parseFloat(val) + 1) >= 0;
export const formatNumber = ({
  number, currency, decimals, ...rest
}) => {
  const floatNumber = parseFloat(number);
  const intNumber = floatNumber.toFixed(0);
  const numberLength = intNumber.toString().length;
  const minusSignCorrection = (floatNumber < 0) ? -1 : 0;
  let decimalsParsed = parseInt(decimals, 10);
  // eslint-disable-next-line no-restricted-globals
  if (isNaN(decimalsParsed)) decimalsParsed = 0;
  return floatNumber.toPrecision(numberLength + minusSignCorrection + decimalsParsed);
};
export const round = (number, places) => +(`${Math.round(`${number}e+${places}`)}e-${places}`);
export const autoFormatCurrency = (number, options = { forceDecimals: false, addWhiteSpace: false }) => {
  const symbol = localStorage.getItem('moneda');
  const numberOfDecimals = localStorage.getItem('digitos_moneda');
  const floatNumber = parseFloat(number);
  let whiteSpace = options.addWhiteSpace ? ' ' : '';
  if (options.forceDecimals) {
    const decimalsParsed = parseInt(numberOfDecimals, 10);
    return floatNumber.toFixed(decimalsParsed) + whiteSpace + symbol;
  }
  return round(floatNumber, numberOfDecimals).toString() + whiteSpace + symbol;
};
